import React from 'react';
import { Container, Typography } from '@mui/material';
import PageWrapper from '../components/PageWrapper';

const Homeschool = () => {
    return (
        <PageWrapper configKey="homeschool" pageTitle="Homeschool Support Programs">
            {(config) => (
                <Container maxWidth="md" sx={{ mt: 6, mb: 3 }}>
                    <Typography component="p">
                        We are a group of experienced educators who are dedicated to providing our students with a solid educational foundation that has lasting, lifelong effects.
                        <br />
                        <br />
                        We know that each child has passions, talents, and strengths that traditional schools are often unable to meet. At the same time, we appreciate that, whether you are homeschooling or searching for supplemental classes to enrich and inspire, even the most dedicated parents/guardians can be enhanced by our stellar educational program.
                        <br />
                        <br />
                        And that's where we come in. We are devoted to providing comprehensive, in-depth, and high-level instruction that will not only lead to your child's academic success, but also to an enjoyment of learning that will carry through into their future studies, careers, and lives in a digitized, global society.
                        <br />
                        <br />
                        Working closely with families, we seek to guide children's scholastic, social and emotional growth in a holistic way, fostering articulate, independent, confident, and resilient individuals. And, we take some of the pressure off of you in the process.
                        <br />
                        <br />
                        To learn more about our academic and enrichment programs as well as our support network, please reach out to us at <a href="mailto:homeschool@macgillisglobalacademy.net">homeschool@macgillisglobalacademy.net</a>.
                    </Typography>
                </Container>
            )}
        </PageWrapper>
    );
};

export default Homeschool; 